import {css} from '@emotion/css';

import {colours, spacing, elementSize, fonts} from '@fo/shared/styles/variables';
import {mq, Breakpoints, layout} from '@fo/shared/styles/mixins';

const styles = {
  container: css`
    label: heroTextOnly__container;
    position: relative;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    min-height: 20rem;
  `,
  contents: css`
    label: heroTextOnly__contents;
    ${layout.containerStackMobile};
    position: relative;
    z-index: 2;
    width: 100%;
    min-width: ${elementSize.container.MIN};
    margin-right: auto;
    margin-left: auto;
    padding: 0;
    ${mq(Breakpoints.DESKTOP)} {
      padding: ${spacing.XS} 0;
    }
    h1 {
      line-height: 1;
      font-size: ${fonts.size.H2};
    }
    p:last-of-type {
      margin-bottom: 0;
    }
    color: ${colours.font.BLACK};
  `,
  text: css`
    label: heroTextOnly__text;
    ${layout.columnFull};
    margin-bottom: ${spacing.XXS};

    ${mq(Breakpoints.TABLET)} {
      flex: 0 1 auto;
      margin-bottom: 0;
    }

    ${mq(Breakpoints.DESKTOP)} {
      ${layout.columnHalf};
    }
  `,
  cta: css`
    label: heroTextOnly__cta;
    margin-top: ${spacing.XS};
  `,
  children: css`
    label: heroTextOnly__children;
    ${layout.columnFull};
    display: flex;
    justify-content: center;
    padding-top: ${spacing.XXS};
    text-align: center;

    ${mq(Breakpoints.TABLET)} {
      flex: none;
      padding-top: 0;
    }

    ${mq(Breakpoints.DESKTOP)} {
      ${layout.columnHalf};
      justify-content: flex-end;
    }

    // TODO: add better way to override trustpilot component styles

    .trustpilot-widget {
      width: 25rem;
      height: 2rem;
      padding-top: 0;
      border-radius: 1rem;

      a,
      a:visited,
      a:hover,
      a:active {
        display: block;
        width: 100%;
        color: ${colours.general.WHITE};
        text-align: center;
      }

      ${mq(Breakpoints.TABLET)} {
        width: 25rem;
        height: 13rem;
        padding: ${spacing.XXS} 0 0 ${spacing.XXS};
        background-color: ${colours.font.BLACK};
      }
    }
  `,

  layoutContainer: css`
    label: heroTextOnly__layoutContainer;
    padding-bottom: 0;
    ${mq(Breakpoints.DESKTOP)} {
      padding: ${spacing.XS} 0;
    }
  `,
};

export default styles;
